import {createAsyncThunk} from '@reduxjs/toolkit';

import {profilePackagesService} from '../../services';
import {type} from './state';
import {ApiResponse} from "../../models";
import {createClearAllAsyncThunk, createClearErrorAsyncThunk} from "../shared-actions";

export const getAllProfilePackages = createAsyncThunk<ApiResponse, {customerId?: number, learnerId?: number}>(
    `${type}/getAllProfilePackages`,
    async (args, {rejectWithValue}) => {
        try {
            const {customerId, learnerId} = args;
            return await profilePackagesService.getAll(customerId, learnerId);
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const getProfilePackageById = createAsyncThunk<ApiResponse, {id: number, customerId?: number}>(
    `${type}/getProfilePackageById`,
    async (args, {rejectWithValue}) => {
        try {
            const {id, customerId} = args;
            return await profilePackagesService.getById(id, customerId);
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const setSelectedIdAction = createAsyncThunk(
    `${type}/setSelectedIdAction`,
    async (arg: { id: number }) => {
        const {id} = arg;
        const result = await profilePackagesService.setSelectedId(id);
        return {
            selectedId: result.id,
        };
    }
);

export const clearErrorsAction = createClearErrorAsyncThunk(type);
export const clearAllAction = createClearAllAsyncThunk(type);

